<form #f="ngForm" (ngSubmit)="f.form.valid && confirmSignOtp()" appFocusFirstElement>
    <h2 mat-dialog-title>
      <span *ngIf="!isNotAttestedUser">{{'title.input_identify_otp' | translate}}</span>
      <span *ngIf="isNotAttestedUser">{{'title.input_verify_subject_otp' | translate}}</span>
      <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <mat-divider></mat-divider>
    <mat-dialog-content>
      <div class="form-group row mt-3">
        <div class="col-12">
          <mat-form-field class="w-100">
            <mat-label>{{'form.code_confirm_identify' | translate}}</mat-label>
            <input #inputOtp (focusout)="focusOut()" (focusin)="focusIn()" matInput [placeholder]="'form.code_confirm_identify' | translate" type="text" name="otp"
              [(ngModel)]="otp" #otpInput="ngModel" maxlength="6" required id="otp" [pattern]="otpPattern" />
            <button mat-button *ngIf="otp" type="button" matSuffix mat-icon-button aria-label="Clear"
              (click)="otp=''">
              <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="otpInput?.errors?.required">
              <span class="text-error">
                {{ 'validation.confirm_code_identify_is_number_re' | translate }}
              </span>
            </mat-error>
            <mat-error *ngIf="otpInput?.errors?.pattern">
              <span class="text-error">
                {{'validation.confirm_code_identify_is_number' | translate}}
              </span>
            </mat-error>
          </mat-form-field>
          <small class="form-text">{{'form.code_confirm_send_to_phone_identify' | translate}} <strong>{{customerDTO.phone}}</strong></small>
        </div>
      </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="center">
      <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-stroked-button color="primary" class="mr-3" (click)="onSendCodeOTPAgain()" type="button">
        <mat-icon class="mr-0">send</mat-icon>
        {{'button.send_code_otp_again' | translate}}
      </button>
      <button mat-raised-button type="submit" [disabled]="!f.form.valid" color="primary">
        <mat-icon class="mr-0">save</mat-icon>
        {{'button.confirm' | translate}}
      </button>
    </mat-dialog-actions>
  </form>
  